"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageRecipient = void 0;
var react_1 = __importDefault(require("react"));
require("./PackageRecipient.scss");
var utils_1 = require("@app/shared/utils");
var constants_1 = require("@server/shared/constants");
var StatusAvatar_1 = require("@app/components/users/StatusAvatar");
var PackageRecipient = function (props) {
    return (react_1.default.createElement("div", { className: "recipient" },
        react_1.default.createElement(StatusAvatar_1.StatusAvatar, { user: props.recipient, showCheckmark: props.hasDownloadedPackage }),
        react_1.default.createElement("div", { className: "recipient-info" },
            react_1.default.createElement("div", { className: "recipient-name has-text-weight-bold" },
                react_1.default.createElement("span", null, utils_1.getUserTitle(props.recipient))),
            react_1.default.createElement("div", { className: "recipient-email" },
                react_1.default.createElement("span", null, props.recipient.lastName !== constants_1.EXTERNAL_EMAIL ? props.recipient.userEmail : '')))));
};
exports.PackageRecipient = PackageRecipient;
